// extracted by mini-css-extract-plugin
export default {"container":"TodoList_container__DBs2s","motivationText":"TodoList_motivationText__cfVfe","list":"TodoList_list__dqQoz"};